// extracted by mini-css-extract-plugin
export default {"input":"AirdropDialog_input__v5KKM"};